import React, { useState, useEffect, useRef } from 'react';
import { HiChevronUpDown } from "react-icons/hi2";

function CustomSingleSelectDropdown({ options, label, searchable = false, value, onChange }) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(value || null);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsOpen((prev) => !prev);
    };

    const handleOptionClick = (option) => {
        if (option === 'Select Project Status') return; // Ignore if it's the default option
        setSelectedOption(option);
        setIsOpen(false);
        if (onChange) {
            onChange(option);
            setIsOpen(true);
        }
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value.toLowerCase());
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };
    

    useEffect(() => {
       // console.log("Dropdown value updated:", value);
        // Sync `selectedOption` with `value`, allowing reset when `value` is null
        setSelectedOption(value);
    }, [value]);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="custom-single-select" ref={dropdownRef}>
            <label>{label}</label>
            <div className="dropdown" onClick={toggleDropdown}>
            <div className="dropdown-head">
                {selectedOption ? selectedOption : `Select ${label}`}  
                <span className="dropdown-icon"><HiChevronUpDown /></span>
            </div>


                {isOpen && (
                    <div className="dropdown-popup">
                        {searchable && (
                            <div className="dropdown-search">
                                <input
                                    type="text"
                                    className="dropdown-search-input"
                                    placeholder={`Search ${label}`}
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    onClick={(e) => e.stopPropagation()}
                                />
                            </div>
                        )}
                        {options.map((categoryGroup, index) => (
                            <div key={index} className="dropdown-category">
                                {categoryGroup.options
                                    .filter((option) =>
                                        !searchable || option.toLowerCase().includes(searchTerm)
                                    )
                                    .map((option, i) => (
                                        <div
                                            key={i}
                                            className={`dropdown-option ${
                                                selectedOption === option ? 'selected' : ''
                                            } ${option === 'Select Project Status' ? 'disabled' : ''}`}
                                            onClick={() => handleOptionClick(option)}
                                        >
                                            {option}
                                        </div>
                                    ))}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default CustomSingleSelectDropdown;
